<template>
  <div>
    <Header title="学籍信息查看"></Header>
    <div class="my-apply1">
      <div class="info-text">
        <p>学号：<span>{{this.xjxxData.xh}}</span></p>
        <p>姓名：<span>{{this.xjxxData.xm}}</span></p>
        <p>性别：<span>{{this.xjxxData.xb}}</span></p>
        <p>院系：<span>{{this.xjxxData.yx}}</span></p>
        <p>专业：<span>{{this.xjxxData.zymc}}</span></p>
        <p>班级：<span>{{this.xjxxData.bj}}</span></p>
        <p>民族：<span>{{this.xjxxData.mz}}</span></p>
        <p>出生日期：<span>{{this.xjxxData.csrq}}</span></p>
        <p>身份证件号：<span>{{this.xjxxData.sfzjh}}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
  import { Api } from '../../../utils/axios'
  export default{
    data(){
      return{
        xjxxData:[],
        status:''
      }
    },
    methods:{
      async getList(){
        const params = {
          alienationId:this.$route.query.id
        }
        const res = await Api.getStudentXjxx(params)
        this.xjxxData = res.data[0]
      }
    },
    created(){
        this.status = this.$route.query.status;
        this.getList()
    },
  }
</script>

<style lang="less" scoped>
  .my-apply1{padding: 1.25rem;}
  .my-apply1 .info-text{font-size: 0.875rem;color: @attendance-color-2;line-height: 1.5625rem;}
  .info-text p span{font-weight: 700;}
</style>



// WEBPACK FOOTER //
// src/components/student/statusManage/xs_xjxxck.vue